import React, {useCallback} from 'react';
import {Layout, Table} from '@phonectas/unifon-ui-kit';
import {useTranslation} from 'react-i18next';
import EmailNotificationTableRow from './EmailNotificationTableRow';

interface EmailNotificationTableProps {
	data: string[] | [];
	onDelete: (index: number) => void;
}

const EmailNotificationTable: React.FC<EmailNotificationTableProps> = ({data, onDelete}) => {
	const [t] = useTranslation();
	const renderItem = useCallback((item: string, index: number) => {
		return (
			<EmailNotificationTableRow
				key={`item:${index}`}
				index={index}
				item={item}
				onDelete={onDelete}
			/>
		);
	}, [onDelete]);

	return (
		<Layout fullWidth>
			<>
				<Table
					items={data ? data : []}
					renderItem={renderItem}
					variant="compact"
				>
					<Table.Row>
						<Table.Cell>{t('Email')}</Table.Cell>
						<Table.Cell width={45}>{t('Delete')}</Table.Cell>
					</Table.Row>
				</Table>
			</>
		</Layout>
	);
}

export default EmailNotificationTable;
